import type { Nullish } from '@/types/nullish';

export function isNullish<T>(input: T | Nullish): input is Nullish {
  return input === null || input === undefined;
}
